export default "__VITE_ASSET__CxDw7tp9__"